import { app } from '../../../../../../bootstrap/core';
import { sortableComponent } from './sortable.component';

app.component('sortable', sortableComponent);
